import styled from "@emotion/styled";
import { Fit } from "@skbkontur/react-stack-layout";
import { KonturColors } from "@skbkontur/colors";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Item = styled.div<{ maxWidth?: number }>(props => ({
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: theme(props).typography.primary.lineHeight.css(),
    maxWidth: Math.max(400, props.maxWidth ?? 0),
}));

export const TotalCount = styled.div({
    maxWidth: 400,
});

export const ValueWrapper = styled.div(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
}));

export const ValueName = styled.span(props => ({
    whiteSpace: "nowrap",
    color: theme(props).typography.secondary.color,
    textOverflow: "ellipsis",
    overflow: "hidden",
}));

export const ReadonlyValueWrapper = styled.div(() => ({
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
}));

export const ItemCode = styled.div({
    whiteSpace: "nowrap",
    display: "table-cell",
    textAlign: "right",
});

export const ItemName = styled.div<{ isGreyValue?: boolean }>(props => ({
    display: "table-cell",
    paddingLeft: 7,
    whiteSpace: "normal",

    [`${ItemCode} + &`]: {
        color: props.isGreyValue ? theme(props).typography.secondary.color : "initial",
    },
}));

export const MostLikelyCaption = styled.div(props => ({
    color: theme(props).typography.secondary.color,
}));

export const HighlightWrapper = styled.span<{ highlighted: boolean; wrapperWidth?: number | string }>(
    props =>
        props.highlighted && {
            boxShadow: `0 0 0 2px ${theme(props).valueControls.highlightedBorderColor}`,
            display: "block",
            width: props.wrapperWidth,
        }
);

export const AutoValueNote = styled(Fit)(props => ({
    ...theme(props).typography.smallFont.css(),
    color: theme(props).typography.secondary.color,
    paddingTop: 10,
}));

export const AddButtonWrapper = styled.div({
    position: "sticky",
    bottom: 0,
    background: KonturColors.grayscaleWhiteFFF,
});
